import { createResponseComposition, context } from 'msw';

const createDelayedResponse = (delay: number) =>
  createResponseComposition(undefined, [context.delay(delay)]);

export const delayedResponse = createDelayedResponse(500);
export const delayedResponseWithDelay = createDelayedResponse;
